import React from 'react';

export const Input = ({ 
  className = '', 
  type = 'text',
  name,
  value,
  onChange,
  placeholder = '',
  ...props 
}) => {
  return (
    <input 
      className={`appearance-none block w-full px-3 py-2 border border-gray-300 
        rounded-md shadow-sm placeholder-gray-400 
        focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${className}`}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default Input; 